import React, { useEffect, useState } from 'react';
import { cellPhoneMask, cpfMask, maskCnpj } from 'js/library/utils/helpers';
import { toast } from 'react-toastify';

// Styles
import * as E from 'js/components/DesignSystem/Table/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import { BoxSearch, ButtonDelete, Input, InputBox, SearchIconButton } from './styles';
import { AddPhotoAlternate } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import searchIcon from 'styles/assets/SearchUser/search.svg';

// Components
import InputFields from './InputFields';

// Apis
import services from './services';
import CustomButtonsTable from 'js/components/TriiboComponents/Tables/CustomButtonsTable';

export const ListOfUsers = (props) => {
  const { setArrayDataToTxt, checkedItems, setCheckedItems, data, setData } = props;
  // const history = useHistory();
  const partnerId = localStorage.getItem('partnerIdClube');
  const establishmentId = props?.match?.params?.id;
  const isSeuClube = window.location.pathname.includes('seu-clube') ? 'club' : 'establishment';

  const [loadingValidateUserMapfre, setLoadingValidateUserMapfre] = useState(true);

  const [cellPhone, setCellPhone] = useState('');
  const [cpf, setCpf] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [email, setEmail] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [clubKey, setClubKey] = useState('');
  const [token, setToken] = useState('');
  const [verifyEmail, setVerifyEmail] = useState(false);

  // arquivo
  const [file, setFile] = useState(null);

  // dados da tabela
  const [filteredResults, setFilteredResults] = useState([]);
  const [dataUsers, setDataUsers] = useState({
    key: '',
    name: '',
    uId: '',
  });

  const column = [
    { heading: isSeuClube === 'club' ? 'Chave do clube' : 'Celular do usuário', value: 'key' },
    { heading: 'Uid', value: 'uId' },
    { heading: 'Usuário que pode ver a notificação', value: 'name' },
  ];

  useEffect(() => {
    if (isSeuClube === 'establishment') {
      setClubKey('');
    }
  }, [isSeuClube]);

  useEffect(() => {
    if (partnerId !== '-Kx8jpgL7X-e_aJf0R7B-ClubMapfre') {
      setLoadingValidateUserMapfre(false);
    }

    if (partnerId === '-Kx8jpgL7X-e_aJf0R7B-ClubMapfre' && token?.length < 11) {
      setLoadingValidateUserMapfre(true);
    }
  }, [partnerId, token]);

  useEffect(() => {
    // se o clubKey estiver vazio, buscar o token
    if (isSeuClube === 'club' && clubKey) {
      // caso seja clubmapfre
      if (partnerId === '-Kx8jpgL7X-e_aJf0R7B-ClubMapfre' && token?.length === 11) {
        services.getUserClubMapfre(token, partnerId, setDataUsers, setLoadingValidateUserMapfre);
      } else {
        // para saber se o usuário pertence ao clube
        services.getUsersPartner(partnerId, clubKey, setDataUsers);
      }
    } else if (isSeuClube === 'establishment') {
      // para saber se o usuário pertence ao estabelecimento
      services.getClients(establishmentId, setDataUsers);
    } else {
      // seta o token do clube
      services.getClubToken(partnerId, setClubKey);
    }
  }, [isSeuClube, partnerId, clubKey, token?.length === 11]);

  // se algum dos textFields mudar, limpa a mensagem de erro
  useEffect(() => {
    setErrorMessage('');
  }, [cellPhone, cpf, cnpj, email]);

  useEffect(() => {
    // limpa o state data sempre que a opção: lista de usuário direcionada for false, e limpa o textField
    if (!checkedItems.item2) {
      setData([]);
      setCellPhone('');
      setCpf('');
      setCnpj('');
      setEmail('');
    }
  }, [checkedItems]);

  // removendo a máscara e adicionando +55
  const removeMask = (value) => value.replace(/\D/g, ''); // remove qualquer caractere que não seja número
  const formatPhoneNumber = (phone) => {
    const cleanPhone = removeMask(phone);
    return `+55${cleanPhone}`;
  };

  useEffect(() => {
    const tokenMap = {
      cellPhone: formatPhoneNumber(cellPhone),
      cpf: removeMask(cpf),
      cnpj: removeMask(cnpj),
      email: email,
    };

    // atualiza o token sem a máscara e com +55 para celular
    setToken(tokenMap[clubKey]);
  }, [clubKey, cellPhone, cpf, cnpj, email]);

  const validateEmail = (email) => {
    if (!email) {
      setVerifyEmail(false); // email vazio = inválido
      return false;
    }

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const isValid = emailRegex.test(email);
    setVerifyEmail(isValid);
    return isValid;
  };

  useEffect(() => {
    if (data.length > 0) {
      setFilteredResults(data);

      // transforma o array data em um txt
      const keys = data.map((user) => user.key).join('\n');

      const content = `${clubKey}\n${keys}`;
      const blob = new Blob([content], { type: 'text/plain' });
      const fileAsTxt = new File([blob], 'usuarios.txt', { type: 'text/plain' });
      setArrayDataToTxt(fileAsTxt);
    } else {
      setFile(null);
    }
  }, [data]);

  // para verificar e remover duplicados quando o state data for atualizado
  useEffect(() => {
    if (data.length > 0) {
      // cria um conjunto para rastrear chaves únicas
      const uniquePhoneNumbers = new Set();
      // filtra os dados para manter apenas chaves únicas
      const filteredData = data.filter((item) => {
        if (!uniquePhoneNumbers.has(item.key)) {
          uniquePhoneNumbers.add(item.key);
          return true;
        }
        return false;
      });
      // verifica se houve alteração nos dados antes de atualizar o state data
      if (filteredData.length !== data.length) {
        setData(filteredData);
      }
    }
  }, [data]);

  // para quando insere usuários por arquivo
  useEffect(() => {
    const readFileContent = async () => {
      if (!file) return;

      try {
        // valida o tipo do arquivo antes de ler
        if (file.type !== 'text/plain' && file.type !== 'text/csv') {
          toast.error('Formato inválido! Use .txt ou .csv.', { autoClose: 2500 });
          setFile(null);
          return;
        }

        // lê o conteúdo do arquivo
        const reader = new FileReader();
        const content = await new Promise((resolve, reject) => {
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = () => reject(new Error('Falha ao ler o arquivo'));
          reader.readAsText(file);
        });

        // processa os dados
        const dataFile = content
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line.length > 0);

        if (dataFile.length === 0) {
          toast.error('O arquivo não possui dados válidos.', { autoClose: 2500 });
          setFile(null);
          return;
        }

        // função de validação aprimorada
        const validateLine = (line) => {
          const cleanLine =
            clubKey === 'cellPhone' ||
            clubKey === 'cpf' ||
            clubKey === 'cnpj' ||
            isSeuClube === 'establishment'
              ? line.replace(/\D/g, '') // remove tudo que não for número (somente para dados numéricos)
              : line.trim(); // mantém emails sem alterar

          if (isSeuClube === 'club') {
            // validação baseada no clubKey
            switch (clubKey) {
              case 'cpf':
                return cleanLine.length === 11 && /^\d{11}$/.test(cleanLine);
              case 'cnpj':
                return cleanLine.length === 14 && /^\d{14}$/.test(cleanLine);
              case 'cellPhone':
                return (
                  cleanLine.startsWith('55') &&
                  cleanLine.length >= 12 &&
                  cleanLine.length <= 13 &&
                  /^55\d{10,11}$/.test(cleanLine)
                );
              case 'email':
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(line);
              default:
                return false;
            }
          } else if (isSeuClube === 'establishment') {
            // para estabelecimentos, apenas telefones são válidos
            return (
              cleanLine.startsWith('55') &&
              cleanLine.length >= 12 &&
              cleanLine.length <= 13 &&
              /^55\d{10,11}$/.test(cleanLine)
            );
          }

          return false; // caso não se encaixe em nenhuma regra
        };

        // filtra linhas inválidas
        const invalidLines = dataFile.filter((line) => !validateLine(line));

        if (invalidLines.length > 0) {
          toast.error(`${invalidLines.length} dado(s) inválido(s) para o tipo ${clubKey}`, {
            autoClose: 4000,
          });
          setFile(null);
          return;
        }

        // converte os dados para o formato correto
        const formattedData = dataFile.map((line) => ({
          key:
            isSeuClube === 'establishment' || clubKey === 'cellPhone'
              ? `+${line.replace(/\D/g, '')}` // telefones
              : line, // CPF, CNPJ e Email mantêm formato origin
          name: '--',
          uId: 'Inserido via arquivo',
        }));

        setData((prevData) => [...prevData, ...formattedData]);
        toast.success(`${formattedData.length} usuário(s) adicionado(s) via arquivo.`, {
          autoClose: 2500,
        });
        toast.warning('Usuários repetidos não serão adicionados.', { autoClose: '2500' });
      } catch (error) {
        console.error('Erro na função (readFileContent):', error);
        toast.error('Erro ao processar o arquivo.', { autoClose: 2500 });
        setFile(null);
      }
    };

    readFileContent();
  }, [file, clubKey, isSeuClube]);

  const handleChangeCheckbox = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  // arquivo
  const fileChangedHandler = (event) => {
    if (event.target.files.length !== 0) {
      setFile(event.target.files[0]);

      // reseta o valor do input para permitir a inclusão de um arquivo com o mesmo nome
      event.target.value = null;
    }
  };

  // arquivo
  const handleFileButtonClick = () => {
    document.getElementById('usersList').click();
  };

  // barra de pesquisa da tabela
  const handleSearch = (e) => {
    const term = e.target.value.trim();
    setSearchTerm(term);

    const filtered = data.filter(
      (user) =>
        user.key?.includes(term) ||
        user.uId?.toLowerCase().includes(term) ||
        user.name?.toLowerCase().includes(term)
    );
    setFilteredResults(filtered);
  };

  // adiciona usuário na tabela pelo textField
  const addUser = () => {
    let userToAdd = null;
    let userExists = false;

    if (isSeuClube === 'club') {
      userExists = data.some((user) => user.key === token);

      if (userExists) {
        toast.error('Esse usuário já foi adicionado!');
        return;
      }

      const isValidToken =
        (clubKey === 'cellPhone' && token?.length === 14) ||
        (clubKey === 'cpf' && token?.length === 11) ||
        (clubKey === 'cnpj' && token?.length === 14) ||
        (verifyEmail && token.includes('.com'));

      if (!isValidToken) {
        toast.error(`Digite um ${clubKey} válido.`);
        return;
      }
      const usersArray = Array.isArray(dataUsers) ? dataUsers : [dataUsers];

      // busca o usuário pelo token (clubKey) digitado
      userToAdd = usersArray.find((user) => user.key === token);
    } else {
      if (cellPhone.length !== 15) {
        toast.error('Digite um número de celular válido.');
        return;
      }

      const cleanPhone = removeMask(cellPhone);
      const phoneKey = `+55${cleanPhone}`;

      userToAdd = dataUsers.find((user) => user.key === phoneKey);
      userExists = data.some((user) => user.key === phoneKey);

      if (userExists) {
        toast.error('Esse usuário já foi adicionado!');
        return;
      }
    }

    if (userToAdd) {
      setData((prevData) => [...prevData, userToAdd]);
      toast.success('Usuário adicionado à lista.');

      setCellPhone('');
      setCpf('');
      setCnpj('');
      setEmail('');
      setToken('');
      setLoadingValidateUserMapfre(true);
    } else {
      toast.error(
        isSeuClube === 'club'
          ? 'Usuário não encontrado.'
          : 'Esse usuário não é um cliente desse estabelecimento.'
      );
    }
  };

  // apaga usuário da tabela
  const deleteUser = (key) => {
    setData((prevData) => prevData.filter((user) => user.key !== key));
    toast.success('Usuário removido da lista.');
  };

  const componentReceiver = (column, childrens) => {
    return {
      columnComponent: (
        <>
          <E.TableTH>Excluir</E.TableTH>
        </>
      ),
      childrenComponent:
        childrens === null ? null : (
          <>
            <E.TableTD>
              <ButtonDelete onClick={() => deleteUser(childrens.key)}>
                <DeleteIcon size={10} />
              </ButtonDelete>
            </E.TableTD>
          </>
        ),
    };
  };

  // textfield para adicionar usuarios a lista (clube e estabelecimento)
  const { renderInputByClubKey, renderInputEstablishment } = InputFields({
    cellPhone,
    setCellPhone,
    cpf,
    setCpf,
    cnpj,
    setCnpj,
    email,
    setEmail,
    verifyEmail,
    validateEmail,
    cellPhoneMask,
    cpfMask,
    maskCnpj,
    addUser,
    loadingValidateUserMapfre,
  });

  return (
    <>
      <FormControl>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          <FormControlLabel
            control={
              <Checkbox checked={checkedItems.item1} onChange={handleChangeCheckbox} name="item1" />
            }
            label="Lista de membros do clube"
          />
          <FormControlLabel
            control={
              <Checkbox checked={checkedItems.item2} onChange={handleChangeCheckbox} name="item2" />
            }
            label="Lista de usuário direcionada"
          />
        </Box>
      </FormControl>

      {checkedItems.item2 && (
        <Accordion sx={{ marginTop: '20px' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            Lista de usuários
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
              }}
            >
              {clubKey ? renderInputByClubKey(clubKey) : renderInputEstablishment()}

              <Tooltip
                title={
                  isSeuClube === 'club'
                    ? 'Atenção! Só é possível adicionar membros desse clube.'
                    : 'Atenção! Só é possível adicionar usuários que possuem relação com o estabelecimento.'
                }
                placement="top"
              >
                <span>
                  <HelpOutlineIcon sx={{ color: '#b1aeae' }} />
                </span>
              </Tooltip>
            </Box>

            {errorMessage !== '' && (
              <Typography color="red" variant="subtitle2" sx={{ marginTop: '5px' }}>
                {errorMessage}
              </Typography>
            )}

            <FormLabel component="legend" sx={{ marginTop: '40px' }}>
              Arquivo com a lista de usuários{' '}
              {isSeuClube === 'club' && clubKey ? `(chave: ${clubKey}) - Exemplo: ` : '- Exemplo: '}
              {(() => {
                switch (clubKey) {
                  case 'cellPhone':
                    return '+5511000000000';
                  case 'cpf':
                    return '43911929909';
                  case 'email':
                    return 'example@triibo.com.br';
                  case 'cnpj':
                    return '31959924000143';
                  default:
                    return '+5511000000000';
                }
              })()}
              <br />
              Precisa ser no formato .txt ou .csv
            </FormLabel>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
              }}
            >
              <input
                id="usersList"
                accept=".txt"
                style={{ display: 'none' }}
                type="file"
                onChange={fileChangedHandler}
              />
              <label
                htmlFor="usersList"
                style={{
                  display: 'flex',
                  gap: '20px',
                  alignItems: 'center',
                }}
              >
                <Button
                  sx={{ textTransform: 'capitalize', fontWeight: '550' }}
                  variant="contained"
                  color="secondary"
                  startIcon={<AddPhotoAlternate />}
                  onClick={handleFileButtonClick}
                >
                  Adicionar Arquivo
                </Button>
                {file && (
                  <Box sx={{ fontSize: '14px' }}>
                    <b>Arquivo selecionado: </b>
                    {file.name}
                  </Box>
                )}
              </label>
            </Box>

            {data.length > 0 ? (
              <>
                <BoxSearch style={{ width: '100%', marginTop: '60px' }}>
                  <InputBox style={{ borderBottom: '1px solid #ccc' }}>
                    <Input
                      placeholder="Pesquisar usuário..."
                      onChange={handleSearch}
                      value={searchTerm}
                    />
                    <SearchIconButton onClick={(e) => e.preventDefault()}>
                      <img src={searchIcon} alt="" />
                    </SearchIconButton>
                  </InputBox>
                </BoxSearch>

                {filteredResults.length > 0 ? (
                  <Box sx={{ marginTop: '20px' }}>
                    <CustomButtonsTable
                      data={filteredResults}
                      column={column}
                      perPage={10}
                      componentReceiver={componentReceiver}
                      loadingTableDisabled={true}
                    />
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
                    <strong>Nenhum resultado encontrado.</strong>
                  </Box>
                )}
              </>
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
                <strong>Nenhum usuário adicionado.</strong>
              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};
